import { render } from "./selectArrow.vue?vue&type=template&id=1db1d31d"
const script = {}

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__